import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import * as css from './style.css';

interface OrderSummaryProps {
    nameFirst: string;
    nameLast: string;
    creditCard?: string;
    ticketsAmount: number;
    ticketTitle: string;
    oid: string;
}

function OrderSummary({ 
    nameFirst, 
    nameLast, 
    creditCard, 
    ticketsAmount, 
    ticketTitle, 
    oid 
}: OrderSummaryProps) {
    const {t} = useTranslation('suspendedConfirmation');

    const orderDetails = useMemo(() => [
        `${nameFirst} ${nameLast}`,
        creditCard ? `************${creditCard}` : null,
        `${t(ticketsAmount > 1 ? 'multipleTickets' : 'singleTicket', {amount: ticketsAmount})} ${ticketTitle}`,
        t('orderNumber', {oid})
    ], [nameFirst, nameLast, creditCard, ticketsAmount, ticketTitle, oid, t]);

    return (
        <css.confirmationBoxFlexStart>
            <css.boldText style={{marginBottom: '16px'}}>{t('yourInvitation')}:</css.boldText>
            {orderDetails.map(row => row && (
                <css.infoRow style={{marginBottom: '8px'}} key={row}>{row}</css.infoRow>
            ))}
        </css.confirmationBoxFlexStart>
    );
}

export default OrderSummary; 